import type { CardsTranslations } from "../interfaces/cards";

export const cardsTranslations: CardsTranslations = {
  edit_alias_modal_title: "Editar Alias de Tarjeta",
  edit_alias_modal_description:
    "El alias es un nombre personalizado que te ayuda a identificar fácilmente esta tarjeta en tu lista.",
  edit_alias_label: "Alias",
  edit_alias_placeholder: "Ingresa un alias para la tarjeta",
  edit_alias_error_required: "El alias es requerido",
  edit_alias_error_min_length: "El alias debe tener al menos 1 carácter",
  edit_alias_error_max_length: "El alias no puede tener más de 26 caracteres",
  edit_alias_error_load_data: "Error al cargar los datos de la tarjeta",
  edit_alias_button_update: "Actualizar",
  edit_alias_button_cancel: "Cancelar",
  edit_alias_success_message: "El alias se ha actualizado correctamente",
  edit_alias_error_message: "Error al actualizar el alias de la tarjeta",
  card_detail_title: "Tarjeta",
  card_detail_back_to_list: "Volver a la lista",
  card_detail_status_label: "Estado:",
  card_detail_select_status: "Seleccionar estado",
  card_detail_loading: "Cargando información de la tarjeta...",
  card_detail_error_load: "Error al cargar la tarjeta",
  card_detail_error_load_movements: "Error al cargar los movimientos",
  card_detail_error_load_more_movements: "Error al cargar más movimientos",
  card_detail_error_generate_url: "Error al generar la URL de visualización",
  card_detail_status_update_success: "Estado de la tarjeta actualizado exitosamente",
  card_detail_status_update_error: "Error al actualizar el estado de la tarjeta",
  movements_title: "Movimientos",
  movements_loading: "Cargando movimientos...",
  movements_refresh: "Actualizar",
  movements_empty: "No hay movimientos para mostrar",
  movements_load_more: "Mostrar más movimientos",
  movements_loading_more: "Cargando más movimientos...",
  movements_show_more_aria: "Mostrar más movimientos",
  movements_status_pending: "Pendiente",
  movements_status_completed: "Completado",
  movements_status_failed: "Fallido",
  movements_status_reversed: "Revertido",
  txn_detail_title: "Detalle de movimiento",
  txn_detail_subtitle: "Detalle de transacción",
  txn_detail_loading: "Cargando detalle...",
  txn_detail_error_title: "No pudimos cargar el movimiento",
  txn_detail_error_description: "Ocurrió un problema al obtener el detalle. Inténtalo de nuevo.",
  txn_detail_retry: "Reintentar",
  txn_detail_close: "Cerrar",
  txn_detail_section_movement: "Movimiento",
  txn_detail_section_performed_by: "Realizado por",
  txn_detail_section_where: "Dónde",
  txn_detail_section_conversion: "Conversión de moneda",
  txn_detail_field_type: "Tipo",
  txn_detail_field_operation: "Operación",
  txn_detail_field_description: "Descripción",
  txn_detail_field_merchant: "Comercio",
  txn_detail_field_category: "Categoría",
  txn_detail_field_location: "Ubicación",
  txn_detail_field_terminal: "Terminal / POS",
  txn_detail_field_exchange_rate: "Tasa de cambio",
  txn_detail_field_spot_variation: "Variación spot",
  txn_detail_field_performed_by_name: "Nombre",
  txn_detail_field_performed_by_email: "Correo",
  txn_detail_operation_credit: "Crédito (+)",
  txn_detail_operation_debit: "Débito (−)",
  txn_type_purchase: "Compra",
  txn_type_topup: "Carga",
  txn_type_deposit: "Depósito",
  txn_type_refund: "Reembolso",
  txn_type_atm_withdrawal: "Retiro en cajero",
  txn_type_withdrawal: "Retiro",
  txn_type_fee: "Comisión",
  txn_type_transfer: "Transferencia",
  txn_type_reversal: "Reverso",
  txn_type_adjustment: "Ajuste",
  mcc_category_taxi_rideshare: "Taxis",
  mcc_category_public_transit: "Transporte público",
  mcc_category_airlines: "Aerolíneas",
  mcc_category_travel: "Viajes y agencias",
  mcc_category_car_rental: "Renta de autos",
  mcc_category_lodging: "Hoteles",
  mcc_category_groceries: "Supermercados",
  mcc_category_restaurants: "Restaurantes",
  mcc_category_fast_food: "Comida rápida",
  mcc_category_bars: "Bares",
  mcc_category_liquor: "Licorerías",
  mcc_category_fuel: "Gasolineras",
  mcc_category_automotive: "Automotriz",
  mcc_category_apparel: "Ropa",
  mcc_category_shoes: "Calzado",
  mcc_category_jewelry: "Joyería",
  mcc_category_electronics: "Electrónica",
  mcc_category_department_stores: "Tiendas departamentales",
  mcc_category_discount_stores: "Tiendas de descuento",
  mcc_category_furniture: "Muebles",
  mcc_category_home_improvement: "Ferretería y hogar",
  mcc_category_books_stationery: "Librerías y papelería",
  mcc_category_sporting_goods: "Artículos deportivos",
  mcc_category_toys_hobby: "Juguetes y pasatiempos",
  mcc_category_gifts: "Regalos",
  mcc_category_florist: "Floristerías",
  mcc_category_pets: "Mascotas",
  mcc_category_cosmetics: "Cosméticos",
  mcc_category_music_media: "Música y video",
  mcc_category_general_retail: "Compras varias",
  mcc_category_wholesale: "Mayoreo",
  mcc_category_technology: "Tecnología",
  mcc_category_telecom: "Telecomunicaciones",
  mcc_category_utilities: "Servicios públicos",
  mcc_category_entertainment: "Entretenimiento",
  mcc_category_gambling: "Apuestas y casinos",
  mcc_category_medical: "Servicios médicos",
  mcc_category_pharmacy: "Farmacias",
  mcc_category_education: "Educación",
  mcc_category_financial: "Servicios financieros",
  mcc_category_insurance: "Seguros",
  mcc_category_real_estate: "Bienes raíces",
  mcc_category_professional_services: "Servicios profesionales",
  mcc_category_personal_care: "Cuidado personal",
  mcc_category_repair_services: "Reparaciones",
  mcc_category_cleaning_laundry: "Limpieza y lavandería",
  mcc_category_contractors: "Contratistas",
  mcc_category_shipping: "Envíos y paquetería",
  mcc_category_government: "Gobierno",
  mcc_category_charity: "Donaciones y ONG",
  mcc_category_membership_orgs: "Organizaciones",
  mcc_category_services_other: "Otros servicios",
  card_visual_loading: "Cargando tarjeta...",
  card_visual_view_title: "Vista de tarjeta",
  card_visual_copy_number: "Copiar número",
  card_visual_expires: "Exp.",
  card_visual_cvv: "CVV",
  update_status_modal_title: "Cambiar Estado",
  update_status_modal_button_cancel: "Cancelar",
  update_status_modal_button_confirm: "Cambiar estado",
  update_status_modal_warning_title: "Cambiar estado de la tarjeta",
  update_status_modal_confirmation_message: "¿Estás seguro de que deseas cambiar el estado de la tarjeta de",
  update_status_modal_to: "a",
  status_active: "Activa",
  status_frozen: "Congelada",
  status_disabled: "Deshabilitada",
  status_deleted: "Eliminada",
  status_pending_review: "Pendiente de revisión",
  table_header_name: "Nombre",
  table_header_alias: "Alias",
  table_header_provider: "Proveedor",
  table_header_last4: "Últimos 4 dígitos",
  table_header_type: "Tipo",
  table_header_product: "Producto",
  table_header_status: "Estado",
  table_header_actions: "Acciones",
  table_showing_cards: "Mostrando",
  table_showing_cards_singular: "tarjeta",
  table_showing_cards_plural: "tarjetas",
  table_showing_total: "Total",
  table_show: "Mostrar:",
  table_tooltip_view_detail: "Ver detalle de la tarjeta",
  table_tooltip_edit: "Editar tarjeta",
  table_tooltip_view_detail_en: "Card detail",
  table_tooltip_edit_en: "Edit card",
  type_credit: "Crédito",
  type_debit: "Débito",
  type_prepaid: "Prepaga",
  product_virtual: "Virtual",
  product_physical: "Física",
  provider_visa: "Visa",
  provider_mastercard: "Mastercard",
  provider_amex: "Amex",
  provider_discover: "Discover",
  provider_other: "Otro",
  filters_title: "Filtros",
  filters_search_alias_placeholder: "Buscar por alias...",
  filters_clear: "Limpiar Filtros",
  filters_select_status: "Seleccionar estado",
  filters_select_provider: "Seleccionar proveedor",
  filters_select_type: "Seleccionar tipo",
  filters_select_product: "Seleccionar producto",
  filters_cards_created: "TARJETAS CREADAS",
  cards_not_found: "No se encontraron tarjetas",
  cards_loading: "Cargando tarjetas...",
  cards_error_load: "Error al cargar las tarjetas",
  pagination_first_page: "Primera página",
  pagination_previous_page: "Página anterior",
  pagination_next_page: "Página siguiente",
  pagination_last_page: "Última página",
  pagination_total_pages: "Total de páginas",
  identities_table_header_name: "Nombre",
  identities_table_header_document_number: "Número de documento",
  identities_table_header_nationality: "Nacionalidad",
  identities_table_header_type: "Tipo",
  identities_table_header_status: "Estado",
  identities_table_header_actions: "Acciones",
  identities_table_header_cards: "Tarjetas",
  identities_table_showing: "Mostrando",
  identities_table_showing_singular: "identidad",
  identities_table_showing_plural: "identidades",
  identities_table_show: "Mostrar:",
  identities_table_tooltip_view_detail: "Ver detalle de la identidad",
  identities_table_tooltip_view_detail_en: "Identity detail",
  identities_table_tooltip_create_card: "Crear tarjeta",
  identities_table_tooltip_create_card_en: "Create card",
  identities_type_select: "Seleccionar",
  identities_status_active: "Activa",
  identities_status_pending_review: "Pendiente de revisión",
  identities_status_rejected: "Rechazada",
  identities_header_new_identity_person: "+ Nueva identidad (persona)",
  identities_header_new_identity_business: "+ Nueva identidad (empresa)",
  identities_header_filter_select_type: "Seleccionar tipo",
  identities_header_identities_created: "IDENTIDADES CREADAS",
  identities_not_found: "No se encontraron identidades",
  identities_loading: "Cargando identidades...",
  identities_error_load: "Error al cargar las identidades",
  identities_error_create_card: "Error al crear la tarjeta",
  create_identity_modal_title: "Nueva Identidad (persona)",
  create_identity_modal_button_cancel: "Cancelar",
  create_identity_modal_button_create: "Crear titular",
  create_identity_section_organization_title: "Identidad de Organización",
  create_identity_section_organization_description:
    "Indica si esta identidad pertenece a la organización misma (su identidad corporativa). Puede ser individual (persona natural) o business (empresa). Si envía otro, se reemplazará el anterior.",
  create_identity_section_organization_checkbox: "Esta identidad pertenece a la organización",
  create_identity_section_identity_title: "Información de Identidad",
  create_identity_section_identity_description: "Datos personales y de contacto de la identidad",
  create_identity_section_address_title: "Dirección",
  create_identity_section_address_description: "Información de ubicación y dirección",
  create_identity_label_type: "Tipo de Identidad",
  create_identity_label_email: "Email",
  create_identity_label_first_name: "Nombre",
  create_identity_label_last_name: "Apellido",
  create_identity_label_birthdate: "Fecha de Nacimiento",
  create_identity_label_gender: "Género",
  create_identity_label_nationality: "Nacionalidad",
  create_identity_label_personal_id_type: "Tipo de Documento",
  create_identity_label_personal_id_number: "Número de Documento",
  create_identity_label_phone: "Teléfono",
  create_identity_label_country: "País",
  create_identity_label_city: "Ciudad",
  create_identity_label_postal_code: "Código Postal",
  create_identity_label_address_type: "Tipo de Dirección",
  create_identity_label_address_line_1: "Dirección Línea 1",
  create_identity_label_address_line_2: "Dirección Línea 2",
  create_identity_label_state: "Estado/Departamento",
  create_identity_gender_male: "Masculino",
  create_identity_gender_female: "Femenino",
  create_identity_gender_other: "Otro",
  create_identity_id_type_cc: "CC - Cédula de Ciudadanía",
  create_identity_id_type_ce: "CE - Cédula de Extranjería",
  create_identity_id_type_passport: "PASSPORT - Pasaporte",
  create_identity_id_type_nit: "NIT - Número de Identificación Tributaria",
  create_identity_id_type_ppt: "PPT - Permiso por Protección Temporal",
  create_identity_id_type_ine: "INE - Credencial para Votar",
  create_identity_id_type_rfc: "RFC - Registro Federal de Contribuyentes",
  create_identity_id_type_dni: "DNI - Documento Nacional de Identidad",
  create_identity_id_type_le: "LE - Libreta de Enrolamiento",
  create_identity_id_type_lc: "LC - Libreta Cívica",
  create_identity_id_type_ci: "CI - Cédula de Identidad",
  create_identity_id_type_rg: "RG - Registro General",
  create_identity_id_type_cnh: "CNH - Licencia Nacional de Conducción",
  create_identity_id_type_national_id: "NATIONAL_ID - Documento de Identidad Nacional",
  create_identity_id_type_driver_license: "DRIVER_LICENSE - Licencia de Conducir",
  create_identity_id_type_residence_permit: "RESIDENCE_PERMIT - Permiso de Residencia",
  create_identity_id_type_cuil: "CUIL - Código Único de Identificación Laboral",
  create_identity_id_type_cpf: "CPF - Registro de Personas Físicas",
  create_identity_id_type_cnpj: "CNPJ - Registro de Personas Jurídicas",
  create_identity_id_type_ruc: "RUC - Registro Único de Contribuyentes",
  create_identity_id_type_rut: "RUT - Rol Único Tributario",
  create_identity_id_type_tax_id: "TAX_ID - Identificación Tributaria",
  create_identity_label_id_country: "País del documento",
  create_identity_label_identification_type: "Tipo de documento",
  create_identity_label_identification_number: "Número de documento",
  create_identity_address_type_registration: "REGISTRATION",
  create_identity_address_type_shipping: "SHIPPING",
  create_identity_address_type_billing: "BILLING",
  create_identity_address_type_kyc: "KYC",
  create_identity_error_address_line_1_required: "La dirección línea 1 es requerida",
  create_identity_error_address_line_2_required: "La dirección línea 2 es requerida",
  create_identity_error_city_required: "La ciudad es requerida",
  create_identity_error_state_required: "El estado/departamento es requerido",
  create_identity_error_country_required: "El país es requerido",
  create_identity_error_postal_code_required: "El código postal es requerido",
  create_identity_error_email_required: "El email es requerido",
  create_identity_error_email_invalid: "El email no es válido",
  create_identity_error_first_name_required: "El nombre es requerido",
  create_identity_error_last_name_required: "El apellido es requerido",
  create_identity_error_birthdate_required: "La fecha de nacimiento es requerida",
  create_identity_error_gender_required: "El género es requerido",
  create_identity_error_nationality_required: "La nacionalidad es requerida",
  create_identity_error_personal_id_number_required: "El número de documento es requerido",
  create_identity_error_personal_id_type_required: "El tipo de documento es requerido",
  create_identity_error_id_type_invalid_for_country:
    "El tipo de documento no es válido para la nacionalidad seleccionada",
  create_identity_error_cpf_digits: "El CPF debe tener 11 dígitos.",
  create_identity_error_cnpj_length: "El CNPJ debe tener 14 caracteres.",
  create_identity_error_phone_required: "El teléfono es requerido",
  create_business_identity_modal_title: "Nueva Identidad (empresa)",
  create_business_identity_section_company_title: "Información de la Empresa",
  create_business_identity_section_company_description: "Datos comerciales y legales de la empresa",
  create_business_identity_section_owner_title: "Información del Representante Legal",
  create_business_identity_section_owner_description:
    "Datos personales del representante legal de la empresa",
  create_business_identity_section_owner_address_title: "Dirección del Representante Legal",
  create_business_identity_section_owner_address_description:
    "Información de ubicación y dirección del representante legal",
  create_business_identity_section_company_address_title: "Dirección de la Empresa",
  create_business_identity_section_company_address_description:
    "Información de ubicación y dirección de la empresa",
  create_business_identity_label_name: "Nombre Comercial",
  create_business_identity_label_business_type: "Tipo de Entidad",
  create_business_identity_label_legal_name: "Razón Social",
  create_business_identity_label_tax_id: "NIT / Número de Identificación Tributaria",
  create_business_identity_label_incorporation_date: "Fecha de Incorporación",
  create_business_identity_label_country_name: "País (Nombre)",
  create_business_identity_label_country_code: "Código del País (ISO3)",
  create_business_identity_label_identification_type: "Tipo de documento (empresa)",
  create_business_identity_label_identification_number: "Número de documento (empresa)",
  create_business_identity_label_owner_name: "Nombre del Representante Legal",
  create_business_identity_label_owner_id_type: "Tipo de Documento del Representante Legal",
  create_business_identity_label_owner_id_number: "Número de Documento del Representante Legal",
  create_business_identity_label_owner_address_line1: "Dirección Línea 1",
  create_business_identity_label_owner_city: "Ciudad",
  create_business_identity_label_owner_state: "Estado/Provincia",
  create_business_identity_label_owner_postal_code: "Código Postal",
  create_business_identity_label_owner_country_code: "Código del País (ISO3)",
  create_business_identity_business_type_llc: "LLC",
  create_business_identity_business_type_sa: "S.A.",
  create_business_identity_business_type_corp: "Corp",
  create_business_identity_business_type_sas: "S.A.S.",
  create_business_identity_business_type_sociedad_anonima: "Sociedad Anónima",
  create_business_identity_business_type_sociedad_limitada: "Sociedad Limitada",
  create_business_identity_business_type_corporacion: "Corporación",
  create_business_identity_business_type_sa_de_cv: "S.A. de C.V.",
  create_business_identity_business_type_s_de_rl_de_cv: "S. de R.L. de C.V.",
  create_business_identity_business_type_sapi_de_cv: "S.A.P.I. de C.V.",
  create_business_identity_business_type_sc: "S.C.",
  create_business_identity_business_type_persona_fisica_ae: "Persona física con actividad empresarial",
  create_business_identity_id_type_ssn: "SSN - Social Security Number",
  create_business_identity_id_type_rut: "RUT - Registro Único Tributario",
  create_business_identity_error_name_required: "El nombre comercial es requerido",
  create_business_identity_error_business_type_required: "El tipo de entidad es requerido",
  create_business_identity_error_legal_name_required: "La razón social es requerida",
  create_business_identity_error_tax_id_required: "El NIT/Número de identificación tributaria es requerido",
  create_business_identity_error_tax_id_invalid: "El NIT solo debe contener letras y números",
  create_business_identity_error_incorporation_date_required: "La fecha de incorporación es requerida",
  create_business_identity_error_country_name_required: "El nombre del país es requerido",
  create_business_identity_error_country_code_required: "El código del país es requerido",
  create_business_identity_error_owner_name_required: "El nombre del representante legal es requerido",
  create_business_identity_error_owner_id_type_required:
    "El tipo de documento del representante legal es requerido",
  create_business_identity_error_owner_id_number_required:
    "El número de documento del representante legal es requerido",
  create_business_identity_error_owner_address_line1_required:
    "La dirección del representante legal es requerida",
  create_business_identity_error_owner_city_required: "La ciudad del representante legal es requerida",
  create_business_identity_error_owner_state_required: "El estado del representante legal es requerido",
  create_business_identity_error_owner_postal_code_required:
    "El código postal del representante legal es requerido",
  create_business_identity_error_owner_country_code_required:
    "El código del país del representante legal es requerido",
  identity_detail_title: "Detalle de Identidad",
  identity_detail_back_to_list: "Volver a la lista",
  identity_detail_loading: "Cargando información de la identidad...",
  identity_detail_error_load: "Error al cargar la identidad",
  identity_detail_status_label: "Estado:",
  identity_detail_section_personal_title: "Información Personal",
  identity_detail_section_address_title: "Dirección",
  identity_detail_section_kyc_title: "Estado KYC",
  identity_detail_label_full_name: "Nombre completo",
  identity_detail_label_email: "Email",
  identity_detail_label_phone: "Teléfono",
  identity_detail_label_gender: "Género",
  identity_detail_label_document_type: "Tipo de documento",
  identity_detail_label_document_number: "Número de documento",
  identity_detail_label_address_line_1: "Dirección línea 1",
  identity_detail_label_address_line_2: "Dirección línea 2",
  identity_detail_label_city: "Ciudad",
  identity_detail_label_country: "País",
  identity_detail_label_created_at: "Fecha de creación",
  identity_detail_not_specified: "No especificado",
  identity_detail_gender_male: "Masculino",
  identity_detail_gender_female: "Femenino",
  identity_detail_gender_other: "Otros",
  identity_detail_kyc_status_pending: "Pendiente",
  identity_detail_kyc_status_in_review: "En revisión",
  identity_detail_kyc_status_verified: "Verificado",
  identity_detail_kyc_status_rejected: "Rechazado",
  identity_detail_kyc_status_expired: "Expirado",
  organizations_table_header_name: "Nombre",
  organizations_table_header_email: "Email",
  organizations_table_header_phone: "Teléfono",
  organizations_table_header_status: "Estado",
  organizations_table_header_card_provider: "Proveedor de tarjetas",
  organizations_table_header_actions: "Acciones",
  organizations_table_showing: "Mostrando",
  organizations_table_showing_singular: "organización",
  organizations_table_showing_plural: "organizaciones",
  organizations_table_show: "Mostrar:",
  organizations_table_tooltip_view_detail: "Ver detalle de organización",
  organizations_table_tooltip_view_detail_en: "Organization detail",
  organizations_table_tooltip_edit: "Editar organización",
  organizations_table_tooltip_edit_en: "Edit organization",
  organizations_table_tooltip_delete: "Eliminar organización",
  organizations_table_tooltip_delete_en: "Delete organization",
  organizations_status_active: "Activo",
  organizations_status_inactive: "Inactivo",
  organizations_status_suspended: "Suspendido",
  organizations_status_pending: "Pendiente",
  organizations_provider_bloque: "Coloca Cards",
  organizations_provider_crypto_mate: "Coloca Crypto",
  organizations_provider_na: "N/A",
  organizations_header_new_organization: "+ Nueva organización",
  organizations_header_organizations_created: "ORGANIZACIONES CREADAS",
  organizations_not_found: "No se encontraron organizaciones",
  organizations_loading: "Cargando organizaciones...",
  organizations_error_load: "Error al cargar las organizaciones",
  organizations_error_update: "Error al actualizar la organización",
  organizations_error_delete: "Error al eliminar la organización",
  organizations_error_create: "Error al crear la organización",
  organizations_success_update: "Organización actualizada exitosamente",
  organizations_success_create: "Organización creada exitosamente",
  organization_detail_modal_title: "Detalle de Organización",
  organization_detail_error_load: "Error al cargar los detalles de la organización",
  organization_detail_status_label: "Estado:",
  organization_detail_section_basic_title: "Información Básica",
  organization_detail_section_additional_title: "Información Adicional",
  organization_detail_label_name: "Nombre:",
  organization_detail_label_slug: "Slug:",
  organization_detail_label_email: "Email:",
  organization_detail_label_phone: "Teléfono:",
  organization_detail_label_card_provider: "Proveedor de Tarjetas:",
  organization_detail_label_created_at: "Creado:",
  organization_detail_label_updated_at: "Actualizado:",
  organization_detail_not_available: "N/A",
  update_organization_modal_title: "Actualizar Organización",
  update_organization_modal_button_cancel: "Cancelar",
  update_organization_modal_button_update: "Actualizar",
  update_organization_modal_description: "Datos básicos de la organización",
  update_organization_label_card_provider: "Proveedor de Tarjetas",
  update_organization_label_status: "Estado",
  update_organization_label_name: "Nombre",
  update_organization_label_email: "Email",
  update_organization_label_slug: "Slug",
  update_organization_label_phone: "Teléfono",
  update_organization_info_phone: "Número internacional con código de país (sin el símbolo +)",
  update_organization_error_load_data: "Error al cargar los datos de la organización",
  update_organization_validation_name_required: "El nombre es requerido",
  update_organization_validation_name_min_length: "El nombre debe tener al menos 2 caracteres",
  update_organization_validation_name_max_length: "El nombre no puede tener más de 255 caracteres",
  update_organization_validation_slug_max_length: "El slug no puede tener más de 255 caracteres",
  update_organization_validation_email_required: "El email es requerido",
  update_organization_validation_email_invalid: "El email no es válido",
  update_organization_validation_email_max_length: "El email no puede tener más de 255 caracteres",
  update_organization_validation_phone_max_length: "El teléfono no puede tener más de 20 caracteres",
  delete_organization_modal_title: "Eliminar Organización",
  delete_organization_modal_button_cancel: "Cancelar",
  delete_organization_modal_button_delete: "Eliminar",
  delete_organization_modal_warning: "Esta acción no se puede deshacer",
  delete_organization_modal_confirmation_message:
    "¿Estás seguro de que deseas eliminar la organización {{organizationName}}? Esta acción eliminará permanentemente todos los datos asociados a esta organización.",
  delete_organization_success_modal_title: "Organización Eliminada",
  delete_organization_success_modal_button_ok: "OK",
  delete_organization_success_modal_message: "La organización se ha eliminado correctamente.",
  create_organization_modal_title: "Nueva Organización",
  create_organization_modal_button_cancel: "Cancelar",
  create_organization_modal_button_create: "Crear Organización",
  create_organization_modal_description: "Datos básicos de la organización",
  create_organization_info_slug: "Se generará automáticamente desde el nombre si se deja vacío",
  create_organization_validation_name_required: "El nombre es requerido",
  create_organization_validation_name_min_length: "El nombre debe tener al menos 2 caracteres",
  create_organization_validation_name_max_length: "El nombre no puede tener más de 255 caracteres",
  create_organization_validation_slug_max_length: "El slug no puede tener más de 255 caracteres",
  create_organization_validation_email_required: "El email es requerido",
  create_organization_validation_email_invalid: "El email no es válido",
  create_organization_validation_email_max_length: "El email no puede tener más de 255 caracteres",
  create_organization_validation_phone_max_length: "El teléfono no puede tener más de 20 caracteres",
  cards_header_title_organizations: "Organizaciones",
  cards_header_title_identities: "Titulares",
  cards_header_title_cards: "Tarjetas",
  cards_header_title_movements: "Movimientos",
  cards_header_title_configuration: "Configuración",
  cards_header_title_pockets: "Bolsillos",
  cards_tab_label_organizations: "Organizaciones",
  cards_tab_label_identities: "Titulares",
  cards_tab_label_cards: "Tarjetas",
  cards_tab_label_pockets: "Bolsillos",
  balance_refresh_btn: "Actualizar saldo",
  two_factor_required_to_create_card: "Activa la autenticación en dos pasos para crear tarjetas",
  two_factor_required_to_view_card: "Activa la autenticación en dos pasos para ver los datos de la tarjeta",
  two_factor_required_to_topup_card: "Activa la autenticación en dos pasos para cargar o retirar saldo",
  two_factor_required_to_move_card: "Activa la autenticación en dos pasos para mover saldo entre tarjetas",
  two_factor_required_modal_title: "Autenticación en dos pasos requerida",
  two_factor_required_modal_cancel: "Cancelar",
  two_factor_required_modal_go_to_settings: "Ir a configuración",
  two_factor_challenge_title: "Verifica tu identidad",
  two_factor_challenge_description:
    "Ingresa el código de 6 dígitos de tu app de autenticación para continuar.",
  two_factor_challenge_submit: "Verificar",
  two_factor_challenge_error_invalid_code: "Código incorrecto. Inténtalo de nuevo.",
  no_permission_contact_admin: "No tienes permiso para esta acción. Contacta al administrador.",
  wallet_banner_label: "Wallet de tarjetas · USD",
  wallet_banner_status_active: "Activa",
  wallet_banner_description:
    "Lo que retiras de una tarjeta vuelve aquí y lo puedes cargar en otra al instante.",
  wallet_banner_btn_movements: "Movimientos",
  wallet_banner_topup_coming_soon: "Próximamente: carga directa al saldo principal.",
  wallet_banner_allocation_available: "En la wallet",
  wallet_banner_allocation_available_description: "Saldo libre · aún no asignado a bolsillos ni tarjetas",
  wallet_banner_allocation_pockets: "En bolsillos",
  wallet_banner_allocation_pockets_description: "Distribuido entre todos los bolsillos",
  wallet_banner_allocation_cards: "En tarjetas",
  wallet_banner_allocation_cards_description: "Cargado en tarjetas activas",
  wallet_banner_error_load: "No pudimos cargar el saldo de la wallet de tarjetas. Intenta de nuevo.",
  wallet_banner_loading: "Cargando saldo...",
  wallet_movements_eyebrow_back: "Tarjetas",
  wallet_movements_export: "Exportar",
  wallet_movements_refresh: "Actualizar",
  wallet_movements_stat_balance_label: "En la wallet",
  wallet_movements_stat_balance_description: "Disponible total",
  wallet_movements_stat_in_label: "Entró este período",
  wallet_movements_stat_in_description: "Cargas y entradas",
  wallet_movements_stat_out_label: "Salió este período",
  wallet_movements_stat_out_description: "Transferencias y retiros",
  wallet_movements_history_title: "Historial",
  wallet_movements_history_transfer_button: "Transferir",
  wallet_movements_filter_all: "Todos",
  wallet_movements_filter_topup: "Cargas",
  wallet_movements_filter_transfer: "Transferencias",
  wallet_movements_filter_withdrawal: "Retiros",
  wallet_movements_filter_fee: "Comisiones",
  pockets_activate_title: "¿Necesitas agrupar tarjetas por equipo o proyecto?",
  pockets_activate_subtitle:
    "Activa Bolsillos para compartir saldo entre varias tarjetas y separar presupuestos.",
  pockets_activate_button: "Activar bolsillos",
  pockets_placeholder_title: "Próximamente",
  pockets_placeholder_description:
    "Estamos construyendo Bolsillos para que puedas agrupar tarjetas y compartir saldo entre ellas.",
  wallet_movements_title: "Movimientos de la wallet de tarjetas",
  wallet_movements_subtitle:
    "Recargas, transferencias a bolsillos y tarjetas, y comisiones. No incluye gastos hechos con tarjetas.",
  wallet_movements_back: "Volver a tarjetas",
  wallet_movements_breadcrumb: "Movimientos de la wallet de tarjetas",
  wallet_movements_filter_type_label: "Tipo",
  wallet_movements_filter_type_all: "Todos los tipos",
  wallet_movements_filter_direction_label: "Dirección",
  wallet_movements_filter_direction_all: "Todas",
  wallet_movements_filter_status_label: "Estado",
  wallet_movements_filter_status_all: "Todos los estados",
  wallet_movements_filter_date_from: "Desde",
  wallet_movements_filter_date_to: "Hasta",
  wallet_movements_filter_clear: "Limpiar filtros",
  wallet_movements_type_topup: "Recarga",
  wallet_movements_type_transfer: "Transferencia",
  wallet_movements_type_withdrawal: "Retiro",
  wallet_movements_type_fee: "Comisión",
  wallet_movements_type_deposit: "Depósito",
  wallet_movements_type_reversal: "Reverso",
  wallet_movements_type_adjustment: "Ajuste",
  wallet_movements_direction_in: "Entrada",
  wallet_movements_direction_out: "Salida",
  wallet_movements_status_pending: "Pendiente",
  wallet_movements_status_completed: "Completado",
  wallet_movements_status_failed: "Fallido",
  wallet_movements_status_reversed: "Revertido",
  wallet_movements_empty: "Sin movimientos",
  wallet_movements_empty_description:
    "Aún no hay movimientos en este saldo. Cuando realices una recarga o transferencia, aparecerán aquí.",
  wallet_movements_loading: "Cargando movimientos...",
  wallet_movements_error_load: "No pudimos cargar los movimientos. Intenta de nuevo.",
  create_card_modal_title: "Crear Tarjeta",
  create_card_modal_button_cancel: "Cancelar",
  create_card_modal_button_create: "Crear Tarjeta",
  create_card_modal_info_message: "Crear nueva tarjeta",
  create_card_modal_confirmation_message:
    "¿Estás seguro de que deseas crear una tarjeta para la identidad {{identityName}}? Se generará una nueva tarjeta asociada a esta identidad y estará disponible para su uso.",
  create_card_success_modal_title: "Tarjeta Creada",
  create_card_success_modal_button_ok: "OK",
  create_card_success_modal_message: "La tarjeta se ha creado correctamente.",
  nationality_col: "Colombiana",
  nationality_mex: "Mexicana",
  nationality_arg: "Argentina",
  nationality_chl: "Chilena",
  nationality_per: "Peruana",
  nationality_ecu: "Ecuatoriana",
  nationality_bra: "Brasileña",
  nationality_pan: "Panameña",
  nationality_usa: "Estadounidense",
  nationality_esp: "Española",
  card_new_button: "Nueva tarjeta",
  card_new_button_coming_soon: "Próximamente: crea tarjetas directo desde aquí.",
  card_new_requires_eligible_holder:
    "El titular debe estar activo y con KYC aprobado para emitir una tarjeta.",
  holder_new_button: "Nuevo titular",
  pocket_new_button: "Nuevo bolsillo",
  pocket_new_button_coming_soon: "Próximamente: podrás crear bolsillos para agrupar tarjetas.",
  pocket_new_disabled_tooltip: "Apagado temporalmente",
  pocket_topup_disabled_tooltip: "Apagado temporalmente",
  cards_list_section_title: "Todas las tarjetas",
  cards_list_results_label: "resultados",
  cards_load_more: "Cargar más",
  cards_loading_more: "Cargando más tarjetas...",
  cards_list_of_total: "de",
  cards_filter_all: "Todas",
  cards_filter_virtual: "Virtuales",
  cards_filter_fisica: "Físicas",
  cards_filter_frozen: "Congeladas",
  cards_filter_pending: "Pendientes",
  cards_filter_no_pocket: "Sin bolsillo",
  cards_view_list: "Vista lista",
  cards_view_grid: "Vista cuadrícula",
  cards_sort_label: "Ordenar",
  cards_sort_newest: "Más recientes",
  cards_sort_oldest: "Más antiguas",
  cards_sort_balance_high: "Mayor saldo",
  cards_sort_balance_low: "Menor saldo",
  cards_search_placeholder: "Buscar alias, ··4 dígitos…",
  cards_balance_own: "Saldo propio",
  cards_balance_pocket_prefix: "Bolsillo · ",
  cards_label_balance_card: "Saldo tarjeta",
  cards_label_balance_pocket: "Saldo bolsillo",
  cards_label_month_spend: "Gastado este mes",
  cards_label_shared_among: "compartido entre {{n}} tarjetas",
  cards_type_virtual_short: "VRT",
  cards_type_fisica_short: "FÍS",
  cards_list_empty_title: "Sin tarjetas",
  cards_list_empty_description:
    "No encontramos tarjetas con los filtros aplicados. Prueba a limpiar la búsqueda o crear una nueva.",
  cards_status_active: "Activa",
  cards_status_frozen: "Congelada",
  cards_status_disabled: "Deshabilitada",
  cards_status_deleted: "Eliminada",
  cards_status_pending_review: "Pendiente",
  card_detail_export: "Exportar",
  card_detail_tab_overview: "Resumen",
  card_detail_tab_transactions: "Movimientos",
  card_detail_tab_details: "Datos sensibles",
  card_detail_tab_controls: "Controles",
  card_detail_tab_coming_soon_title: "Próximamente",
  card_detail_tab_coming_soon_description: "Esta sección está en construcción.",
  card_detail_action_reveal_show: "Mostrar",
  card_detail_action_reveal_hide: "Ocultar",
  card_detail_action_freeze: "Congelar",
  card_detail_action_unfreeze: "Activar",
  card_detail_action_cancel: "Deshabilitar",
  card_detail_action_cancel_coming_soon:
    "Próximamente: podrás deshabilitar la tarjeta. Esta acción es permanente e irreversible.",
  card_detail_action_email_cardholder: "Enviar al titular",
  card_detail_email_modal_title: "Enviar datos de la tarjeta",
  card_detail_email_modal_description:
    "Mandaremos al titular un enlace seguro para ver los datos completos de su tarjeta.",
  card_detail_email_modal_security_note: "El enlace es de un solo uso y caduca en 15 minutos.",
  card_detail_email_modal_body:
    "Vamos a enviar los datos completos de la tarjeta al correo del titular. ¿Quieres continuar?",
  card_detail_email_button_confirm: "Enviar enlace",
  card_detail_email_button_cancel: "Cancelar",
  card_detail_email_two_factor_title: "Confirma con tu código 2FA",
  card_detail_email_two_factor_description:
    "Introduce el código de tu app de autenticación para enviar el correo.",
  card_detail_email_success: "Se envió un enlace seguro al correo del titular.",
  card_detail_email_error: "No se pudo enviar el correo con los datos de la tarjeta.",
  card_detail_email_error_no_email: "Esta tarjeta no tiene un correo del titular registrado.",
  card_detail_more_options: "Más opciones",
  card_detail_menu_delete: "Eliminar tarjeta",
  card_delete_modal_title: "Eliminar tarjeta",
  card_delete_modal_description: 'Vas a eliminar la tarjeta "{{name}}".',
  card_delete_warning_title: "Esta acción es irreversible",
  card_delete_warning_body:
    "La tarjeta se cancela, deja de funcionar de inmediato y sale de tu lista de tarjetas. Sus movimientos quedan en el historial. Si todavía tiene saldo, devuélvelo al wallet antes de eliminarla.",
  card_delete_cancel: "Cancelar",
  card_delete_confirm: "Eliminar tarjeta",
  card_delete_success: "Tarjeta eliminada.",
  card_delete_error: "No pudimos eliminar la tarjeta. Inténtalo de nuevo.",
  update_status_modal_irreversible_title: "Esta acción es irreversible",
  update_status_modal_irreversible_body:
    "Deshabilitar la tarjeta es permanente: no se puede volver a activar ni recuperar. Si querés pausarla temporalmente, congelala en su lugar.",
  card_detail_info_title: "Información",
  card_detail_info_type: "Tipo",
  card_detail_info_brand: "Marca",
  card_detail_info_pocket: "Bolsillo",
  card_detail_info_holder: "Titular",
  card_detail_info_expires: "Vence",
  card_detail_info_created: "Creada",
  card_detail_overview_spend_month: "Gasto del mes",
  card_detail_overview_loaded_description: "de {{amount}} cargados a la tarjeta",
  card_detail_overview_available_balance: "Saldo disponible · {{amount}}",
  // --- Card detail overview redesign ---
  card_stats_range_7d: "7 días",
  card_stats_range_30d: "30 días",
  card_stats_range_90d: "90 días",
  card_stats_range_mtd: "Mes en curso",
  card_stats_range_ytd: "Año en curso",
  card_stats_range_aria: "Rango de período",
  card_detail_showing_period: "Mostrando datos de los últimos {{label}}",
  card_detail_balance_hero_label: "Saldo disponible",
  card_detail_balance_hero_frozen: "Tarjeta congelada — no acepta cargos.",
  card_detail_balance_hero_no_spend: "Sin gastos en este período.",
  card_detail_balance_hero_runway: "Al ritmo actual ({{rate}}/día) alcanza para ~{{days}} días.",
  card_detail_balance_status_healthy: "Saludable",
  card_detail_balance_status_attention: "Atención",
  card_detail_balance_status_low: "Saldo bajo",
  card_detail_balance_status_empty: "Sin saldo",
  card_detail_balance_status_frozen: "Congelada",
  card_detail_action_load: "Cargar",
  card_detail_action_move: "Mover",
  card_maintenance_banner_title: "Operaciones de saldo en mantenimiento",
  card_maintenance_banner_description:
    "Las cargas, retiros, transferencias de saldo y la creación de tarjetas nuevas están temporalmente deshabilitadas. Si necesitas ayuda, contacta a soporte.",
  card_retry_issuance_title: "Esta tarjeta aún no se pudo emitir",
  card_retry_issuance_description:
    "Los datos del titular ya están guardados. Reintenta la emisión sin volver a llenar nada.",
  card_retry_issuance_action: "Reintentar emisión",
  card_retry_issuance_success: "Tarjeta emitida",
  card_retry_issuance_error: "No pudimos emitir la tarjeta. Intenta de nuevo en unos minutos.",
  card_detail_action_go_to_pocket: "Ir al bolsillo",
  card_detail_pocket_link_label: "Bolsillo",
  card_detail_period_loaded: "Cargado · {{label}}",
  card_detail_period_loaded_count: "{{count}} cargas",
  card_detail_period_spent: "Gastado · {{label}}",
  card_detail_period_spent_count: "{{count}} movimientos",
  card_detail_period_net: "Neto del período",
  card_detail_period_net_positive: "Acumulando saldo",
  card_detail_period_net_negative: "Drenando saldo",
  card_detail_period_net_flat: "Sin cambios",
  card_detail_chart_title: "Gastos en el tiempo",
  card_detail_chart_bucket_day: "Por día",
  card_detail_chart_bucket_week: "Por semana",
  card_detail_chart_bucket_month: "Por mes",
  card_detail_chart_avg: "Promedio {{amount}}/día",
  card_detail_top_merchants_title: "A dónde va el saldo",
  card_detail_top_merchants_subtitle: "Top 4 · {{label}}",
  card_detail_top_merchants_empty: "Sin gastos en este período.",
  // --- Unified balance modal ---
  balance_modal_title: "Saldo de la tarjeta",
  balance_modal_action_load: "Cargar",
  balance_modal_action_withdraw: "Retirar",
  balance_modal_action_move: "Mover",
  balance_modal_withdraw_all: "Retirar todo el saldo a la wallet",
  balance_modal_amount_label: "Monto",
  balance_modal_amount_helper: "Todos los montos en USD",
  balance_modal_sending_load: "Cargando la tarjeta…",
  balance_modal_sending_withdraw: "Retirando a la wallet de tarjetas…",
  balance_modal_sending_move: "Moviendo el saldo…",
  balance_modal_sending_all: "Todo el saldo",
  balance_transit_wallet: "Wallet de tarjetas",
  balance_transit_aria: "{{amount}} van de {{from}} a {{to}}.",
  balance_modal_wallet_balance_label: "Disponible en la wallet",
  balance_modal_card_balance_label: "Saldo de la tarjeta",
  balance_modal_target_card_label: "Tarjeta destino",
  balance_modal_target_card_placeholder: "Elige una tarjeta",
  balance_modal_target_empty:
    "No hay otras tarjetas activas de este mismo tipo a las que puedas mover saldo desde esta.",
  balance_modal_preset_chip_aria: "Usar {{amount}}",
  balance_modal_submit_load: "Cargar saldo",
  balance_modal_submit_withdraw: "Retirar a la wallet",
  balance_modal_submit_move: "Transferir",
  balance_modal_cancel: "Cancelar",
  balance_modal_load_success: "Cargado {{amount}} a la tarjeta.",
  balance_modal_withdraw_success: "Retiraste {{amount}} a la wallet de tarjetas.",
  balance_modal_move_success: "Transferidos {{amount}} a la otra tarjeta.",
  balance_modal_load_error: "No pudimos cargar la tarjeta.",
  balance_modal_withdraw_error: "No pudimos retirar el saldo a la wallet.",
  balance_modal_move_error: "No pudimos transferir entre tarjetas.",
  balance_modal_amount_required: "Ingresa un monto.",
  balance_modal_amount_min: "El monto debe ser mayor a $0.",
  balance_modal_amount_over_wallet: "La wallet de tarjetas no tiene saldo suficiente.",
  balance_modal_amount_over_card: "La tarjeta no tiene saldo suficiente.",
  balance_modal_target_required: "Selecciona una tarjeta destino.",
  card_detail_overview_usage_badge: "{{percent}}% usado",
  card_detail_overview_trend_title: "Tendencia · 6 semanas",
  card_detail_overview_trend_delta: "+{{percent}}% vs sem. anterior",
  card_detail_overview_kpi_transactions: "Transacciones",
  card_detail_overview_kpi_avg_ticket: "Ticket promedio",
  card_detail_overview_kpi_merchants: "Comercios únicos",
  card_detail_overview_kpi_declined: "Declinadas",
  card_detail_overview_kpi_period_month: "este mes",
  card_detail_overview_kpi_period_30d: "últimos 30 días",
  card_detail_overview_top_merchants_title: "Top comercios",
  card_topup_modal_open_button: "Agregar saldo",
  card_topup_modal_title: "Agregar saldo",
  card_topup_modal_description: "Agrega saldo de tu wallet para usar en esta tarjeta.",
  card_topup_label_amount: "Cantidad",
  card_topup_label_currency: "Moneda",
  card_topup_wallet_current_balace: "Saldo actual",
  card_topup_toast_success: "Carga de saldo realizada por {{amount}} {{currency}}.",
  card_balance: "Saldo",
  card_transfer_modal_open_button: "Transferir",
  card_show_data_button: "Ver datos",
  card_hide_data_button: "Ocultar datos",
  card_transfer_label_amount: "Cantidad",
  card_transfer_label_from: "Desde",
  card_transfer_label_to: "Hacia",
  card_transfer_modal_description: "Transfiere saldo a otra tarjeta.",
  card_transfer_modal_title: "Transferir saldo",
  card_transfer_select_card: "Selecciona una tarjeta",
  card_transfer_toast_success: "Transferencia de saldo por {{amount}} {{currency}} realizada.",
  card_withdrawal_modal_open_button: "Restar saldo",
  card_withdrawal_modal_title: "Restar saldo",
  card_withdrawal_modal_description: "Resta saldo de esta tarjeta y devuélvelo a tu wallet.",
  card_withdrawal_toast_success: "Resta de saldo realizada por {{amount}} {{currency}}.",
  // --- Branding / card design customization ---
  branding_button_personalize: "Personalizar",
  branding_page_title: "Personalización de marca",
  branding_page_subtitle: "La vista segura de todas las tarjetas de tu organización",
  branding_summary_title: "Aplicación actual",
  branding_summary_label_gradient: "Gradiente",
  branding_summary_label_logo: "Logo",
  branding_logo_default_coloca: "Coloca (por defecto)",
  branding_logo_custom: "Personalizado",
  branding_preview_alias: "Tu marca · vista previa",
  branding_preview_holder: "Empresa",
  branding_loading: "Cargando configuración…",
  branding_gradient_section_title: "Color de fondo",
  branding_gradient_section_description: "Elige un gradiente curado. Aplica a todas tus tarjetas.",
  branding_logo_section_title: "Logo personalizado",
  branding_logo_section_description: "Aparece en la esquina opuesta al isotipo de Coloca.",
  branding_logo_uploader_idle: "Arrastra tu logo o haz clic para subirlo",
  branding_logo_uploader_constraints: "SVG, PNG o JPG · máx 2 MB · fondo transparente recomendado",
  branding_logo_uploading: "Subiendo logo…",
  branding_logo_loaded_title: "Logo cargado",
  branding_logo_loaded_description: "Aparece en la esquina superior derecha de la tarjeta.",
  branding_logo_button_replace: "Reemplazar",
  branding_logo_button_remove: "Quitar logo",
  branding_logo_error_format: "Formato no soportado. Usa SVG, PNG o JPG.",
  branding_logo_error_size: "Máximo 2 MB.",
  branding_logo_upload_failed: "No pudimos subir el logo.",
  branding_logo_scale_label: "Tamaño del logo",
  branding_button_reset: "Restablecer",
  branding_button_save: "Guardar cambios",
  branding_footer_default: "Estás usando el diseño por defecto.",
  branding_footer_applies_to_all: "Estos cambios aplican a todas las tarjetas de la organización.",
  branding_saved: "Diseño guardado.",
  branding_save_failed: "No pudimos guardar el diseño.",
  branding_reset_done: "Diseño restablecido al de Coloca.",
  branding_reset_failed: "No pudimos restablecer el diseño.",
  branding_locked_badge: "No activa",
  branding_locked_title: "Personaliza el diseño de tus tarjetas",
  branding_locked_description:
    "Elige un gradiente y sube el logo de tu empresa para la vista segura de tus tarjetas, junto a la marca Coloca.",
  branding_locked_cta: "Coloca la activa por organización: pídesela para la tuya.",
  branding_no_org_title: "Selecciona una organización",
  branding_no_org_description:
    "La personalización aplica a nivel de organización. Asocia una organización a tu cuenta para empezar.",
  branding_no_org_description_internal:
    "La personalización aplica a nivel de organización. Abre una organización desde la lista para personalizar su diseño.",
  branding_no_org_cta: "Volver a tarjetas",
  branding_no_org_cta_internal: "Ver organizaciones",
  branding_propagation_notice_title: "Los cambios tardan ~1 minuto",
  branding_propagation_notice_body:
    "Cuando guardas, los nuevos colores y el logo se aplican enseguida a las tarjetas nuevas, pero las que ya están abiertas se pueden demorar hasta 1 minuto en mostrar el cambio. Si cerrás y volvés a abrir el detalle de la tarjeta lo ves de inmediato.",
  branding_saved_with_delay:
    "Diseño guardado. Puede tardar hasta 1 minuto en verse reflejado en tarjetas ya abiertas — cerrá y reabrí el detalle para verlo al instante.",
  branding_logo_uploaded: "Logo subido. Acordate de darle a Guardar para que aplique.",
  branding_explainer_title: "Dónde se ve tu diseño",
  branding_explainer_lead:
    "Tus colores y tu logo se aplican a la vista segura de la tarjeta, la que muestras por API.",
  branding_point_iframe_title: "Solo en la vista segura (iframe)",
  branding_point_iframe_body:
    "Es la vista con los datos de la tarjeta que abres por API con su enlace de vista, y la que ves en el detalle de cada tarjeta.",
  branding_point_wallets_title: "No cambia Apple Pay ni Google Pay",
  branding_point_wallets_body:
    "La tarjeta tokenizada en esas billeteras conserva el diseño estándar de Coloca.",
  branding_point_cobrand_title: "Co-branded con Coloca",
  branding_point_cobrand_body: "Tu logo va junto a la marca Coloca, que siempre aparece en la tarjeta.",
  branding_point_enabled_title: "Se activa por organización",
  branding_point_enabled_on:
    "Coloca ya la activó para tu organización. Si se apaga, la tarjeta vuelve al diseño Coloca y tu diseño queda guardado.",
  branding_point_enabled_off: "Aún no está activa para tu organización. Pídele a Coloca que la active.",
  branding_point_enabled_staff:
    "Se activa en Organizaciones → Funcionalidades → Personalizar tarjeta. Apagada, la tarjeta vuelve al diseño Coloca y el diseño guardado se conserva.",
  branding_diagram_aria:
    "Tu diseño cambia la tarjeta en la vista segura que abres por API; la tarjeta en Apple Pay y Google Pay conserva el diseño estándar",
  branding_diagram_api: "API",
  branding_diagram_secure_view: "Vista segura",
  branding_diagram_wallets: "Apple Pay · Google Pay",
  // --- Holders (Titulares) listing + detail redesign ---
  identities_tier_express: "Express",
  identities_tier_express_perk_one_card: "1 tarjeta virtual",
  identities_tier_express_perk_monthly_cap: "Tope $500 USD/mes",
  identities_tier_verified: "Verificado",
  identities_tier_verified_perk_unlimited_virtual: "Tarjetas virtuales ilimitadas",
  identities_tier_verified_perk_monthly_cap: "Tope $5.000 USD/mes",
  identities_tier_verified_perk_higher_topups: "Recargas más altas",
  identities_tier_pro: "Pro",
  identities_tier_pro_perk_physical: "Tarjetas físicas",
  identities_tier_pro_perk_no_cap: "Sin tope mensual",
  identities_tier_pro_perk_funds_origin: "Procedencia de fondos verificada",
  identities_kyc_approved: "KYC aprobado",
  identities_kyc_pending: "KYC pendiente",
  identities_kyc_rejected: "KYC rechazado",
  identities_stats_total: "Titulares",
  identities_stats_kyc_approved: "KYC aprobado",
  identities_stats_kyc_pending: "KYC pendiente",
  identities_filter_all: "Todos",
  identities_filter_approved: "Aprobados",
  identities_filter_pending: "Pendientes",
  identities_filter_rejected: "Rechazados",
  identities_view_list: "Vista lista",
  identities_view_grid: "Vista cuadrícula",
  identities_search_placeholder: "Buscar por nombre o documento…",
  identities_search_min_length_hint: "Escribe al menos {count} caracteres para buscar.",
  identities_empty_title: "Sin titulares",
  identities_empty_description: "Aún no hay titulares registrados. Crea el primero para empezar.",
  identities_empty_filtered_title: "Sin resultados",
  identities_empty_filtered_description: "Ningún titular coincide con tu búsqueda o tus filtros.",
  identities_label_cards: "Tarjetas",
  identities_label_cards_of: "de",
  identities_list_section_title: "Todos los titulares",
  identities_header_new_person_short: "Nuevo titular",
  identities_header_new_business_short: "Nueva empresa",
  identity_detail_label_birthdate: "Nacimiento",
  identity_detail_stats_cards_active: "Tarjetas activas",
  identity_detail_stats_month_spend: "Gastado este mes",
  identity_detail_kyc_section_title: "Verificación KYC",
  identity_detail_kyc_section_description:
    "Comparte este link con el titular para que complete su verificación. Cópialo o envíalo por correo.",
  identity_detail_kyc_link_placeholder: "Link de verificación",
  identity_detail_kyc_link_valid_until: "Vigente hasta {{date}}",
  identity_detail_kyc_link_expires_in: "Vence en {{time}}",
  identity_detail_kyc_link_expired: "Link vencido",
  identity_detail_kyc_link_empty:
    "No hay un link de verificación vigente. Genera uno nuevo para compartirlo con el titular.",
  identity_detail_kyc_btn_generate: "Generar link",
  identity_detail_kyc_no_recipient:
    "El titular no tiene un correo registrado, así que no hay a quién enviarle el link. Cópialo y compártelo por otro medio.",
  identity_detail_kyc_btn_copy: "Copiar",
  identity_detail_kyc_btn_copied: "Copiado",
  identity_detail_kyc_btn_regenerate: "Regenerar link",
  identity_detail_kyc_btn_send_email: "Enviar por correo",
  identity_detail_kyc_toast_regenerate_success: "Se generó un nuevo link de verificación.",
  identity_detail_kyc_toast_regenerate_error: "No se pudo regenerar el link de verificación.",
  identity_detail_kyc_toast_email_success: "Correo de verificación enviado.",
  identity_detail_kyc_toast_email_error: "No se pudo enviar el correo de verificación.",
  identity_detail_cards_section_title: "Tarjetas del titular",
  identity_detail_cards_empty: "Aún no tiene tarjetas.",
  identity_detail_movements_section_title: "Movimientos",
  identity_detail_movements_coming_soon_title: "Próximamente",
  identity_detail_movements_coming_soon_description:
    "Estamos preparando la vista de movimientos por titular.",
  identity_detail_coming_soon: "Próximamente",
  // --- Unified "Nuevo titular" modal ---
  identities_header_new_holder: "Nuevo titular",
  create_holder_modal_title: "Nuevo titular",
  create_holder_modal_description: "Completa los datos de la persona para crear el titular.",
  create_holder_section_personal: "Datos personales",
  create_holder_section_address: "Dirección",
  create_holder_birthdate_format: "Formato YYYY-MM-DD (por ejemplo 1994-02-17).",
  create_holder_birthdate_placeholder: "Selecciona una fecha",
  create_holder_birthdate_invalid: "Fecha inválida. Selecciona una fecha del calendario.",
  create_holder_phone_invalid_for_country: "Número de teléfono inválido para el país seleccionado.",
  create_holder_success: "Titular creado correctamente.",
  phone_usage_info_button_label: "¿Para qué usamos el teléfono?",
  phone_usage_modal_title: "¿Para qué usamos el teléfono?",
  phone_usage_modal_intro: "Usamos este número de la tarjeta para:",
  phone_usage_item_3ds:
    "Código de seguridad (3DS): en las compras online enviamos un código de un solo uso por SMS que el titular ingresa para confirmar el pago.",
  phone_usage_item_whatsapp:
    "Notificaciones por WhatsApp sobre la actividad de la tarjeta (compras, recargas, devoluciones, bloqueos), si están activadas.",
  phone_usage_modal_note: "Asegúrate de que el número sea correcto y pueda recibir SMS y WhatsApp.",
  // --- "Nueva tarjeta" modal redesign ---
  create_card_modal_description:
    "Asigna a un titular, elige el bolsillo y crea la tarjeta. La carga inicial llega después: hay que esperar a que la tarjeta esté ACTIVE.",
  create_card_no_holder_title: "Primero crea un titular",
  create_card_no_holder_description:
    "Para emitir tarjetas necesitas al menos un titular: la persona a cuyo nombre se crea la tarjeta. Créalo aquí mismo y sigue con la tarjeta, o ve al módulo de titulares para gestionar los que ya existen.",
  create_card_no_holder_button: "Ir a titulares",
  // --- Creating a holder from inside the new-card modal ---
  create_card_new_holder_button: "Nuevo titular",
  create_card_new_holder_title: "Nuevo titular",
  create_card_new_holder_description: "Crea el titular sin perder los datos de la tarjeta que ya llenaste.",
  create_card_new_holder_submit: "Crear titular",
  create_card_holder_created_title: "Titular creado",
  create_card_holder_created_pending:
    "Falta verificar su identidad. Hasta que termine, no se le puede emitir una tarjeta.",
  create_card_holder_created_unknown:
    "No pudimos confirmar su estado. Búscalo en la lista de titulares antes de volver a crearlo.",
  create_card_holder_created_view: "Ver titular",
  create_card_holder_created_done: "Entendido",
  create_card_holder_pending_notice_title: "{{name}} todavía no puede recibir una tarjeta",
  create_card_holder_pending_notice_title_unnamed: "El titular todavía no puede recibir una tarjeta",
  create_card_holder_pending_notice_description:
    "Su identidad está en verificación. Elige otro titular para continuar, o ábrelo para enviarle el enlace de verificación.",
  create_card_label_type: "Tipo de tarjeta",
  create_card_type_virtual_title: "Virtual",
  create_card_type_virtual_description: "Lista en segundos. Ideal para suscripciones y ads.",
  create_card_type_physical_title: "Física",
  create_card_type_physical_description: "Para gastos en sitio. Estamos finalizando la integración.",
  create_card_label_alias: "Alias / Propósito",
  create_card_alias_placeholder: "Ej: Meta Ads · Q2",
  create_card_label_holder: "Titular",
  create_card_search_holder_placeholder: "Buscar por nombre o documento…",
  create_card_change_holder: "Cambiar",
  create_card_no_eligible_holders: "Aún no tienes titulares. Crea uno desde la vista de titulares.",
  create_card_no_matching_holders: "Sin titulares que coincidan con tu búsqueda.",
  create_card_holders_none_eligible_title: "Ningún titular puede recibir una tarjeta todavía",
  create_card_holders_none_eligible_description:
    "Abajo aparecen tus titulares con el motivo que bloquea a cada uno. Para emitir una tarjeta, su verificación de identidad debe estar aprobada. Ábrelos desde la vista de titulares para enviarles el enlace de verificación.",
  create_card_label_pocket: "Bolsillo asociado",
  create_card_label_optional: "opcional",
  create_card_no_pockets_hint: "Aún no hay bolsillos. La tarjeta usará su propio saldo.",
  create_card_search_pocket_placeholder: "Buscar bolsillo…",
  create_card_pocket_none: "Sin bolsillo",
  create_card_pocket_none_description: "La tarjeta usará su propio saldo.",
  create_card_preview_label: "Previsualización",
  create_card_preview_default_alias: "Nueva tarjeta",
  create_card_emission_label: "Emisión",
  create_card_emission_immediate: "Inmediata",
  create_card_provisioning_title: "Carga inicial — más tarde",
  create_card_provisioning_body:
    "El proveedor aprovisiona la tarjeta primero. Hasta que esté Activa no podés cargarle saldo desde tu wallet.",
  create_card_success: "Tarjeta creada. Estamos aprovisionándola con el proveedor.",
  // --- Pockets (Bolsillos) ---
  pockets_error_load: "Error al cargar los bolsillos",
  pockets_list_section_title: "Todos los bolsillos",
  pockets_stats_total: "Bolsillos",
  pockets_stats_total_balance: "Saldo total",
  pockets_stats_cards_linked: "Tarjetas asociadas",
  pockets_stats_month_spend: "Gasto del mes",
  pockets_search_placeholder: "Buscar bolsillo…",
  pockets_empty_title: "Sin bolsillos",
  pockets_empty_description: "Crea uno para agrupar tarjetas por equipo, proyecto o propósito.",
  pocket_edit_button: "Editar",
  pocket_edit_modal_title: "Editar bolsillo",
  pocket_edit_modal_description:
    "Actualiza el nombre, color o icono. El saldo y las tarjetas asociadas se mantienen.",
  pocket_edit_modal_submit: "Guardar cambios",
  pocket_create_modal_title: "Nuevo bolsillo",
  pocket_create_modal_description:
    "Agrupa tarjetas que comparten el mismo saldo. La carga inicial se hace después en un paso aparte.",
  pocket_create_modal_submit: "Crear bolsillo",
  pocket_create_success: "Bolsillo creado.",
  pocket_create_error: "No pudimos crear el bolsillo.",
  pocket_create_no_org: "Necesitas estar en una organización para crear bolsillos.",
  pocket_update_success: "Bolsillo actualizado.",
  pocket_update_error: "No pudimos actualizar el bolsillo.",
  pocket_label_name: "Nombre",
  pocket_label_name_placeholder: "Ej: Marketing Performance",
  pocket_label_color: "Color",
  pocket_label_icon: "Icono",
  pocket_preview_label: "Vista previa",
  pocket_icon_default: "Por defecto",
  pocket_icon_travel: "Viajes",
  pocket_icon_marketing: "Marketing",
  pocket_icon_operations: "Operaciones",
  pocket_icon_saas: "SaaS",
  pocket_icon_shopping: "Compras",
  pocket_icon_gift: "Regalos",
  pocket_icon_food: "Comida",
  pocket_icon_office: "Oficina",
  pocket_icon_team: "Equipo",
  pocket_icon_budget: "Presupuesto",
  pocket_detail_back_to_pockets: "Bolsillos",
  pocket_detail_hero_balance_label: "Saldo del bolsillo",
  pocket_detail_hero_shared_with: "compartido con {{count}} tarjetas",
  pocket_detail_hero_outflow: "Gastado este mes",
  pocket_detail_hero_cards: "Tarjetas",
  pocket_detail_section_cards_title: "Tarjetas",
  pocket_detail_section_cards_empty: "Aún no hay tarjetas en este bolsillo.",
  pocket_detail_section_movements_title: "Movimientos",
  pocket_detail_load_balance: "Cargar bolsillo",
  pocket_detail_transfer: "Transferir",
  pocket_detail_create_card: "Crear tarjeta",
  pocket_delete_button: "Eliminar",
  pocket_delete_modal_title: "Eliminar bolsillo",
  pocket_delete_modal_description: 'Vas a eliminar el bolsillo "{name}". Esta acción no se puede deshacer.',
  pocket_delete_warning:
    "Solo puedes eliminar un bolsillo con saldo en cero y sin tarjetas vinculadas. Si tiene saldo o tarjetas, retira los fondos o elimina las tarjetas primero.",
  pocket_delete_confirm: "Eliminar bolsillo",
  pocket_delete_success: "Bolsillo eliminado.",
  pocket_delete_error: "No pudimos eliminar el bolsillo.",
  cards_pockets_preview_title: "Bolsillos",
  cards_pockets_preview_subtitle: "Tarjetas que comparten saldo agrupadas por equipo o propósito.",
  cards_pockets_preview_view_all: "Ver todos",
  // --- Pocket load/withdraw modal + movements ---
  pocket_load_modal_title: "Movimientos del bolsillo",
  pocket_load_modal_description:
    "Mueve saldo entre el saldo principal y este bolsillo. El proveedor procesa el movimiento de inmediato.",
  pocket_load_mode_topup: "Cargar",
  pocket_load_mode_withdraw: "Devolver",
  pocket_load_submit_topup: "Cargar bolsillo",
  pocket_load_submit_withdraw: "Devolver al saldo",
  pocket_load_wallet_available: "Disponible: {{amount}}",
  pocket_load_wallet_loading: "Cargando saldo principal…",
  pocket_load_pocket_available: "En el bolsillo: {{amount}}",
  pocket_load_pocket_balance_label: "Saldo del bolsillo",
  pocket_load_success_topup: "Cargado {{amount}} al bolsillo.",
  pocket_load_success_withdraw: "Devuelto {{amount}} al saldo principal.",
  pocket_load_pending_reconciliation:
    "El movimiento se ejecutó pero la actualización del registro está pendiente. Aparecerá en unos segundos.",
  pocket_load_error: "No pudimos completar el movimiento.",
  pocket_detail_movements_empty_title: "Sin movimientos",
  pocket_detail_movements_empty_description:
    "Cuando cargues saldo o las tarjetas usen este bolsillo, los movimientos aparecerán aquí.",
  pocket_load_balance_processing_hint:
    "El saldo puede tardar unos segundos en reflejarse mientras el proveedor lo procesa.",

  statement_page_title: "Extracto de tarjeta",
  statement_back_to_card: "Volver a la tarjeta",
  statement_mode_month: "Mes",
  statement_mode_range: "Días",
  statement_mode_lifetime: "Por vida",
  statement_mode_aria: "Período del extracto",
  statement_month_label: "Mes",
  statement_from_label: "Desde",
  statement_to_label: "Hasta",
  statement_error_range_invalid: "La fecha final no puede ser anterior a la inicial.",
  statement_download_pdf: "Descargar PDF",
  statement_loading: "Generando el extracto…",
  statement_error_load: "No pudimos generar el extracto.",
  statement_error_retry: "Reintentar",
  statement_notice_truncated_title: "Extracto recortado",
  statement_notice_truncated_description:
    "Este período tiene {{total}} movimientos y el extracto muestra los primeros {{shown}}. Los totales sí cubren el período completo. Elige un rango más corto para verlos todos.",

  statement_document_title: "Extracto de tarjeta",
  statement_number_label: "N.° de extracto",
  statement_issued_at_label: "Emitido",
  statement_period_label: "Período",
  statement_period_lifetime: "Desde la apertura",
  statement_period_range: "{{from}} — {{to}}",
  statement_card_label: "Tarjeta",
  statement_card_type_label: "Tipo",
  statement_continued: "continuación",

  statement_section_holder: "Titular de la tarjeta",
  statement_section_account: "Cuenta",
  statement_holder_name: "Nombre",
  statement_holder_document: "Documento",
  statement_holder_email: "Correo",
  statement_holder_address: "Dirección",
  statement_account_name: "Razón social",
  statement_account_tax_id: "NIT",
  statement_account_address: "Dirección",
  statement_value_not_available: "No disponible",
  statement_holder_source_fallback_note:
    "† Los datos del titular provienen de la tarjeta; el documento y la dirección no están disponibles.",

  statement_summary_opening_balance: "Saldo inicial",
  statement_summary_closing_balance: "Saldo final",
  statement_summary_loaded: "Cargas",
  statement_summary_spent: "Gastos",
  statement_summary_net: "Neto del período",
  statement_summary_available: "Disponible hoy",
  statement_summary_declined: "Rechazadas",
  statement_summary_pending: "Pendientes",
  statement_summary_movements_count: "{{count}} movimientos",
  statement_summary_estimated_suffix: "estimado",

  statement_section_movements: "Detalle de movimientos",
  statement_table_date: "Fecha",
  statement_table_reference: "Ref.",
  statement_table_merchant: "Descripción",
  statement_table_category: "Categoría",
  statement_table_type: "Tipo",
  statement_table_amount: "Monto",
  statement_table_total_period: "Total neto del período",
  statement_table_empty: "Sin movimientos en este período.",
  statement_badge_declined: "Rechazada",
  statement_badge_pending: "Pendiente",
  statement_badge_reversed: "Reversada",

  statement_footer_issued: "Extracto emitido automáticamente el {{date}}. No requiere firma manuscrita.",
  statement_footer_page: "Página {{current}} de {{total}}",
  statement_footnote_reconciliation:
    "¹ Saldo inicial y final calculados a partir de los movimientos registrados; tómalos como referencia.",
  statement_footnote_truncated: "Se muestran los primeros {{shown}} de {{total}} movimientos del período.",
  statement_footer_declined_excluded: "Las operaciones rechazadas se listan pero no suman en los totales.",

  card_deposit_title: "Depositar stablecoins",
  card_deposit_subtitle:
    "Recarga esta tarjeta enviando stablecoins (monedas digitales atadas al dólar) a su dirección.",
  card_deposit_network_label: "Red",
  card_deposit_address_label: "Dirección de depósito",
  card_deposit_assets_label: "Activos aceptados",
  card_deposit_asset_contract: "Contrato: {{address}}",
  card_deposit_copy: "Copiar dirección",
  card_deposit_copied: "Copiada",
  card_deposit_copied_toast: "Dirección copiada",
  card_deposit_qr_alt: "Código QR de la dirección de depósito en {{network}}",
  card_deposit_warning:
    "Envía solo {{assets}} por la red {{network}}. Cualquier otro activo o red no se acredita y no se puede recuperar. Depósito mínimo: 1 USD.",
  card_deposit_error: "No se pudo cargar la dirección de depósito de la tarjeta. Vuelve a intentarlo.",
  card_deposit_retry: "Reintentar",
  card_deposit_inactive: "Los depósitos no están disponibles mientras la tarjeta no esté activa.",

  // WhatsApp notifications (/app/cards/notifications) — moved out of general Settings.
  notifications_eyebrow: "Producto · Tarjetas",
  notifications_nav_label: "Avisos por WhatsApp",
  notifications_page_title: "Notificaciones por WhatsApp",
  notifications_page_subtitle:
    "Coloca avisa al titular de la tarjeta cuando pasa algo relevante en ella. Activa cada tipo por separado; el cambio aplica a todas las tarjetas emitidas por tu organización.",
  notifications_hero_title: "Avisos al titular de la tarjeta",
  notifications_hero_sub:
    "Mejora la seguridad y la confianza del titular: se entera de cada movimiento en el momento, sin tener que abrir la app.",
  notifications_footnote:
    "El aviso se envía al teléfono registrado en la identidad del titular de cada tarjeta.",

  notifications_topup_name: "Carga de tarjeta",
  notifications_topup_desc: "Avisa al titular cuando se le carga saldo a su tarjeta.",
  notifications_topup_when: "Cuando una tarjeta recibe una recarga acreditada.",
  notifications_declined_name: "Compra rechazada",
  notifications_declined_desc:
    "Avisa al titular cuando una compra es rechazada (por saldo insuficiente, sospecha de fraude, etc.).",
  notifications_declined_when: "Cuando se rechaza una compra con la tarjeta.",
  notifications_reversed_name: "Compra reversada",
  notifications_reversed_desc:
    "Avisa al titular cuando un comercio reversa una compra y el dinero vuelve a su tarjeta.",
  notifications_reversed_when: "Cuando un comercio reversa una compra.",
  notifications_refund_name: "Reembolso recibido",
  notifications_refund_desc: "Avisa al titular cuando un reembolso queda acreditado en su tarjeta.",
  notifications_refund_when: "Cuando un reembolso queda acreditado en la tarjeta.",
  notifications_blocked_name: "Tarjeta bloqueada",
  notifications_blocked_desc: "Avisa al titular cuando su tarjeta queda bloqueada o congelada.",
  notifications_blocked_when: "Cuando la tarjeta queda bloqueada o congelada.",
  notifications_unblocked_name: "Tarjeta desbloqueada",
  notifications_unblocked_desc:
    "Avisa al titular cuando su tarjeta vuelve a quedar activa después de un bloqueo.",
  notifications_unblocked_when: "Cuando una tarjeta bloqueada vuelve a quedar activa.",
  notifications_withdrawal_name: "Retiro de saldo",
  notifications_withdrawal_desc:
    "Avisa al titular cuando se retira saldo de su tarjeta hacia la billetera de la organización.",
  notifications_withdrawal_when: "Cuando se retira saldo de la tarjeta.",
  notifications_balance_low_name: "Saldo bajo",
  notifications_balance_low_desc:
    "Avisa al titular cuando el saldo de su tarjeta cae por debajo del umbral que definas.",
  notifications_balance_low_when: "Cuando el saldo de la tarjeta baja del umbral que definas.",
  notifications_balance_low_threshold_label: "Umbral de saldo bajo",
  notifications_balance_low_threshold_help:
    "Cantidad en USD. Si el saldo de una tarjeta cae por debajo de este valor tras una compra, se envía la alerta.",
  notifications_balance_low_threshold_required_error:
    "Define un umbral positivo en USD antes de activar el aviso.",
  notifications_balance_low_threshold_prefix: "USD",
  notifications_approved_name: "Compra aprobada",
  notifications_approved_desc:
    "Avisa al titular en cada compra aprobada, una sola vez por compra. Genera mucho volumen: actívalo solo si tus clientes lo pidieron.",
  notifications_approved_when: "Cuando se aprueba una compra con la tarjeta.",
  notifications_approved_opt_in_tag: "OPT-IN",

  notifications_enable_confirm_title: "¿Activar el aviso «{{name}}»?",
  notifications_enable_confirm_intro:
    "Al activarlo, Coloca empieza a enviar mensajes reales a los titulares de tus tarjetas.",
  notifications_enable_confirm_who_title: "¿A quién le llega?",
  notifications_enable_confirm_who_body:
    "Al teléfono registrado en la identidad del titular de cada tarjeta.",
  notifications_enable_confirm_when_title: "¿Cuándo?",
  notifications_enable_confirm_reversible:
    "Puedes desactivarlo en cualquier momento — no afecta tarjetas ya emitidas.",
  notifications_enable_confirm_button: "Sí, activar",
  notifications_enable_confirm_cancel: "Cancelar",

  notifications_bubble_topup_body:
    "Hola Cliente, tu recarga de $ 50.000 a la tarjeta terminada en 4321 se procesó exitosamente.\n\nFecha: 21 de mayo de 2026 a las 14:30\nSaldo actual: $ 250.000\nID de transacción: TXN-A8K2R9\n\nGracias por usar Coloca Payments.",
  notifications_bubble_declined_body:
    "Tu compra de USD 3,72 en Netflix no se aprobó.\nMotivo: Fondos insuficientes\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\n¿No fuiste tú? Escríbenos por aquí.",
  notifications_bubble_reversed_body:
    "El comercio reversó tu compra de COP 14.000 en Good One Lab.\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\nEl dinero ya volvió a tu saldo.",
  notifications_bubble_refund_body:
    "Recibiste un reembolso de BRL 14,00 de Uber.\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\nEl saldo ya está disponible.",
  notifications_bubble_blocked_body:
    "Tu tarjeta Coloca •••• 8707 quedó bloqueada.\nMotivo: Varios intentos fallidos de PIN\nSi no fuiste tú quien la bloqueó, escríbenos por aquí.",
  notifications_bubble_balance_low_body:
    "Tu saldo disponible bajó de USD 500,00.\nSaldo actual: USD 438,25\nTarjeta Coloca •••• 8707\nPuedes recargar desde la app de Coloca.",
  notifications_bubble_approved_body:
    "Pagaste COP 14.000 en Good One Lab.\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\n¿No la reconoces? Escríbenos por aquí.",
  notifications_bubble_unblocked_body:
    "Tu tarjeta Coloca •••• 8707 quedó desbloqueada.\n\nYa puedes usarla de nuevo.",
  notifications_bubble_withdrawal_body:
    "Se retiraron USD 120,00 de tu tarjeta Coloca •••• 8707.\nSaldo actual: USD 318,25\n5 oct 2026 · 1:11 p. m.\n\n¿No reconoces este movimiento? Escríbenos por aquí.",
  notifications_bubble_declined_title: "Compra rechazada",
  notifications_bubble_reversed_title: "Compra reversada",
  notifications_bubble_refund_title: "Reembolso recibido",
  notifications_bubble_blocked_title: "Tarjeta bloqueada",
  notifications_bubble_unblocked_title: "Tarjeta desbloqueada",
  notifications_bubble_withdrawal_title: "Retiro de saldo",
  notifications_bubble_balance_low_title: "Saldo bajo",
  notifications_bubble_approved_title: "Compra aprobada",
  notifications_bubble_recipient_hint: "Enviado al teléfono del titular",
  cop_top_up_unavailable_permission: "Tu usuario no tiene permiso para recargar tarjetas desde pesos.",
  cop_top_up_unavailable_card: "Esta tarjeta no recibe recargas desde pesos.",
  cop_top_up_unavailable_card_inactive: "La tarjeta tiene que estar activa.",
  cop_top_up_unavailable_crypto_off: "Cripto no está activo para tu organización.",
  cop_top_up_unavailable_breb_key: "Crea tu llave Bre-B para usar tus pesos.",
  cop_top_up_unavailable_verification: "Termina la verificación de tu organización.",
  cop_top_up_unavailable_fee: "No pudimos leer la comisión de la tarjeta. Intenta en unos minutos.",
  cop_top_up_unavailable_generic: "No disponible por ahora.",
  cop_top_up_title: "Cargar desde pesos",
  cop_top_up_description: "Usamos tu saldo en pesos para cargar la tarjeta •••• {{last4}}.",
  cop_top_up_step_amount: "Monto",
  cop_top_up_step_review: "Revisar",
  cop_top_up_step_result: "Envío",
  cop_top_up_pay_label: "Pagas",
  cop_top_up_credit_label: "Llega a la tarjeta",
  cop_top_up_balance: "Disponible: {{amount}}",
  cop_top_up_limits: "Desde {{min}} por recarga",
  cop_top_up_issue_below_min: "El mínimo es {{min}}.",
  cop_top_up_issue_above_max: "El máximo es {{max}}.",
  cop_top_up_issue_balance: "Tu saldo en pesos no alcanza.",
  cop_top_up_issue_precision: "Revisa los decimales del monto.",
  cop_top_up_issue_invalid: "Escribe un monto válido.",
  cop_top_up_pricing: "Calculando…",
  cop_top_up_type_amount: "Escribe cuánto quieres pagar o cuánto quieres que llegue.",
  cop_top_up_trail_pesos: "Tus pesos",
  cop_top_up_trail_usdt: "Viajan como USDT",
  cop_top_up_trail_card: "Tarjeta •••• {{last4}}",
  cop_top_up_row_pay: "Pagas",
  cop_top_up_row_price: "Precio por dólar",
  cop_top_up_row_sent: "Se envían a la tarjeta",
  cop_top_up_row_fee: "Comisión de recarga de la tarjeta ({{percent}} %)",
  cop_top_up_row_returned: "Devuelto a tu billetera",
  cop_top_up_row_credit: "Llega a la tarjeta",
  cop_top_up_row_paid: "Pagaste",
  cop_top_up_row_sent_done: "Se enviaron a la tarjeta",
  cop_top_up_row_credited: "Llegó a la tarjeta",
  cop_top_up_rate_hint: "Todo incluido: lo que pagaste entre lo que llegó a la tarjeta.",
  cop_top_up_rate_estimated_hint: "Estimada, todo incluido: se confirma cuando la tarjeta acredite.",
  cop_top_up_approx_note: "Lo que llega es un estimado: la tarjeta descuenta su comisión cuando acredita.",
  cop_top_up_irreversible: "Una vez confirmada, la recarga no se puede deshacer.",
  cop_top_up_review: "Revisar",
  cop_top_up_back: "Atrás",
  cop_top_up_confirm: "Cargar {{amount}}",
  cop_top_up_cancel: "Cancelar",
  cop_top_up_close: "Cerrar",
  cop_top_up_refresh_price: "Actualizar precio",
  cop_top_up_price_expired: "El precio venció. Actualízalo para continuar.",
  cop_top_up_ticket_label: "Tu recarga",
  cop_top_up_two_factor_description: "Confirma la recarga de {{amount}} a la tarjeta •••• {{last4}}.",
  cop_top_up_two_factor_required: "Activa la verificación en dos pasos para recargar tarjetas.",
  cop_top_up_status_processing_title: "Estamos enviando tu recarga",
  cop_top_up_status_processing_body:
    "Convertimos tus pesos y los mandamos a la tarjeta. Suele tardar unos minutos.",
  cop_top_up_status_delivered_title: "Ya llegó a la tarjeta",
  cop_top_up_status_delivered_body: "La tarjeta acredita el saldo en cuanto confirma el depósito.",
  cop_top_up_status_credited_title: "Listo, la tarjeta tiene el saldo",
  cop_top_up_status_credited_body: "Se acreditaron {{amount}} a la tarjeta •••• {{last4}}.",
  cop_top_up_status_failed_title: "No se pudo recargar",
  cop_top_up_status_failed_body: "Devolvimos los pesos a tu billetera.",
  cop_top_up_keep_going: "Puedes cerrar esta ventana: la recarga sigue su curso.",
  cop_top_up_transit_wallet: "Billetera COP",
  cop_top_up_transit_card: "Tarjeta",
  cop_top_up_transit_aria:
    "Tus pesos salen de la billetera COP, Coloca los convierte en USDT y viajan por {{network}} a la tarjeta •••• {{last4}}.",
  cop_top_up_error_generic: "No pudimos crear la recarga.",
  cop_top_up_error_unconfirmed:
    "No recibimos respuesta y la recarga pudo haberse hecho. Antes de dejarte hacer otra, comprobamos qué pasó con esta: así nunca se cobra dos veces.",
  cop_top_up_check_unconfirmed: "Comprobar la recarga",
  cop_top_up_check_pending: "Todavía no tenemos la respuesta. Vuelve a comprobar en unos segundos.",
  cop_top_up_check_not_placed: "La recarga anterior no se hizo y no se te cobró. Puedes cotizar de nuevo.",
  cop_top_up_vanished: "Esta recarga fue rechazada antes de comprar: no se hizo y no se te cobró.",
  cop_top_up_start_over: "Cotizar de nuevo",
  txn_type_deposit_cop: "Recarga desde pesos",
  card_wallet_invite_eyebrow: "Wallet de tarjetas",
  card_wallet_invite_title: "¿Necesitas retirar saldo de tus tarjetas?",
  card_wallet_invite_body: "Un saldo en dólares que conecta todas tus tarjetas.",
  card_wallet_invite_cta: "Conocer la wallet",
  card_wallet_invite_status: "Sin activar",
  card_wallet_invite_steps_label: "Cómo funciona",
  card_wallet_invite_step_withdraw: "Retiras saldo de una tarjeta",
  card_wallet_invite_step_hold: "Queda en la wallet",
  card_wallet_invite_step_load: "Lo pasas a otra al instante",
  card_wallet_invite_dismiss: "Ahora no",
  card_wallet_invite_dismissed_title: "Listo, ya no verás este aviso",
  card_wallet_invite_dismissed_body:
    "Si más adelante necesitas retirar saldo de tus tarjetas, activa la wallet desde Ajustes.",
  card_wallet_invite_dismissed_action: "Ir a Ajustes",
  card_wallet_enable_title: "Wallet de tarjetas",
  card_wallet_enable_lead: "Un saldo en dólares que conecta todas tus tarjetas.",
  card_wallet_enable_point_withdraw_title: "Retira saldo de cualquier tarjeta",
  card_wallet_enable_point_withdraw_body: "Lo que retiras vuelve a la wallet y queda disponible.",
  card_wallet_enable_point_load_title: "Carga tarjetas al instante",
  card_wallet_enable_point_load_body:
    "Pasa saldo de la wallet a una tarjeta en segundos, sin comisión de depósito.",
  card_wallet_enable_point_total_title: "Todo tu saldo en un solo lugar",
  card_wallet_enable_point_total_body: "Ves cuánto hay en la wallet y cuánto en cada tarjeta.",
  card_wallet_enable_funding_note:
    "Entra saldo a la wallet cuando retiras de una tarjeta o cuando Coloca te hace una recarga.",
  card_wallet_enable_permanent_note: "Una vez activa, solo el equipo de soporte puede desactivarla.",
  card_wallet_enable_cta: "Activar wallet de tarjetas",
  card_wallet_enable_cancel: "Ahora no",
  card_wallet_enable_success_title: "Wallet de tarjetas activa",
  card_wallet_enable_success_body: "Ya puedes retirar saldo de tus tarjetas y cargarlas desde la wallet.",
  card_wallet_enable_done: "Listo",
  card_wallet_enable_error: "No pudimos activar la wallet de tarjetas. Intenta de nuevo.",
  card_wallet_enable_no_permission: "Pide a un administrador de tu organización que la active.",
  card_wallet_diagram_aria: "La wallet de tarjetas en el centro, con saldo que va y vuelve de tus tarjetas",
  card_wallet_diagram_wallet: "Wallet",
  first_card_eyebrow: "Tu primera tarjeta",
  first_card_title: "Crea tu primera tarjeta",
  first_card_body:
    "Sale a nombre de una persona o empresa y la manejas desde aquí. Esto es lo que necesitas:",
  first_card_step_security_title: "Un método de seguridad",
  first_card_step_security_body:
    "Un PIN de seguridad o la app de autenticación. Con él confirmas la emisión y ves los datos de la tarjeta.",
  first_card_step_holder_title: "Un titular verificado",
  first_card_step_holder_body:
    "La persona o empresa a cuyo nombre sale la tarjeta. Puedes crearlo al emitirla; debe completar la verificación de identidad antes de recibirla.",
  first_card_step_balance_title: "Saldo para usarla",
  first_card_step_balance_body: "Una vez emitida, la cargas y queda lista para pagar.",
  first_card_status_done: "Listo",
  first_card_status_in_review: "En verificación",
  first_card_status_pending: "Pendiente",
  first_card_status_after: "Después de emitirla",
  first_card_cta: "Crear mi primera tarjeta",
  first_card_holders_link: "Ver titulares",
  first_card_diagram_security: "Seguridad",
  first_card_diagram_holder: "Titular",
  first_card_diagram_balance: "Saldo",
  first_card_diagram_card: "Tu tarjeta",
  first_card_diagram_aria:
    "Con un método de seguridad y un titular verificado se emite la tarjeta; después se carga con saldo y queda lista",
  card_load_title: "Cargar tarjeta",
  card_load_description: "Tarjeta •••• {{last4}}",
  card_load_step_source: "Cómo cargar",
  card_load_step_details: "Detalles",
  card_load_source_heading: "¿Cómo quieres cargar?",
  card_load_source_cop: "Desde pesos",
  card_load_source_cop_hint: "Usa tu saldo en pesos. Llega en unos {{minutes}} min.",
  card_load_source_cop_hint_plain: "Usa tu saldo en pesos; la tarjeta lo recibe en dólares.",
  card_load_source_cop_balance: "Disponible: {{amount}}",
  card_load_source_crypto: "Enviando cripto",
  card_load_source_crypto_hint: "USDT o USDC por la red Polygon. Suele tardar entre 2 y 10 min.",
  card_load_source_wallet: "Desde la wallet de tarjetas",
  card_load_source_wallet_hint: "Al instante · Disponible {{amount}}",
  card_load_source_wallet_hint_plain: "Al instante, desde el saldo de la wallet",
  card_load_no_withdraw_notice:
    "Lo que cargues queda en la tarjeta: no se puede retirar, solo moverlo a otra de tus tarjetas.",
  card_load_empty_title: "Esta tarjeta aún no tiene cómo cargarse",
  card_load_empty_body:
    "Escríbenos a soporte y activamos la carga desde pesos o cripto para tu organización.",
  card_load_error: "No pudimos ver las formas de carga de esta tarjeta.",
  card_load_retry: "Reintentar",
  card_load_continue: "Continuar",
  card_load_cancel: "Cancelar",
  card_load_back: "Atrás",
  card_load_close: "Cerrar",
  card_load_unavailable_crypto_off: "La carga con cripto aún no está activa para tu organización.",
  card_load_unavailable_card_inactive: "La tarjeta debe estar activa.",
  card_load_unavailable_card: "Esta tarjeta no admite esta forma de carga.",
  card_load_unavailable_generic: "No disponible por ahora.",
  card_load_crypto_next_title: "Qué pasa después",
  card_load_crypto_next_send: "Envías USDT o USDC a esta dirección, por la red Polygon",
  card_load_crypto_next_confirm: "La red confirma la transacción",
  card_load_crypto_next_credit: "Se acredita en tu tarjeta, menos la comisión de depósito",
  card_load_crypto_eta: "Suele tardar entre 2 y 10 minutos.",
  card_load_timeline_aria: "Avance de la recarga",
  card_load_stage_debited: "Pesos debitados",
  card_load_stage_sending: "Comprando USDT y enviándolo",
  card_load_stage_arrived: "Llegó a tu tarjeta",
  card_load_stage_credited: "Acreditado en tu tarjeta",
  card_load_stage_failed: "No se pudo comprar; devolvimos tus pesos",
  card_load_stage_state_done: "Completado",
  card_load_stage_state_active: "En curso",
  card_load_stage_state_pending: "Pendiente",
  card_load_stage_state_failed: "Falló",
  card_detail_receive_crypto_title: "Recibir cripto",
  card_detail_receive_crypto_body: "Ver la dirección para enviar USDT o USDC a esta tarjeta.",
  card_detail_action_withdraw: "Retirar",
  cop_top_up_ack_no_withdraw:
    "Entiendo que este saldo no se puede retirar de la tarjeta; solo puedo moverlo a otra de mis tarjetas.",
  balance_modal_move_all: "Mover todo el saldo",
  balance_modal_move_all_hint:
    "Incluye las fracciones de centavo que dejan las comisiones, para que la tarjeta quede en cero.",
  balance_modal_move_success_all: "Moviste todo el saldo a la otra tarjeta.",
};
